// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 20%);
}

.optionFilter {
  :global(.ant-select-item-option-state) {
    display: none !important;
  }
}

:where(.css-dev-only-do-not-override-i0102m).ant-select-multiple .ant-select-selection-placeholder {
  color: blue !important;
}

.searchButton {
  background-color: var(--primary-blue-600);
  color: white;
  font-weight: 500;
}

.resetButton {
  color: var(--primary-blue-600);
  font-weight: 500;
}

.downloadButton {
  color: var(--primary-blue-600);
  font-weight: 500;
}

.filterContainer {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

input {
  &::placeholder {
    color: #3b535c !important;
    opacity: 0.75;
  }
}
.dynamicFilterElement {
  &::placeholder {
    color: #212529 !important;
    opacity: 0.5 !important;
  }
  :global(.ant-select-selection-placeholder) {
    color: #212529 !important;
    opacity: 0.5 !important;
  }
}

.dynamicFilterInput {
  &::placeholder {
    color: #212529 !important;
    opacity: 0.5 !important;
  }
  :global(.ant-select-selection-placeholder) {
    color: #212529 !important;
    opacity: 0.5 !important;
  }
}
.dynamicFilterElement {
  width: 19%;
}

.ant-table-pagination.ant-pagination {
  margin: 4px 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/reports/reports.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,yBAAyB;IACzB,aAAa;EACf;AACF;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;AACA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 20%);\n}\n\n.optionFilter {\n  :global(.ant-select-item-option-state) {\n    display: none !important;\n  }\n}\n\n:where(.css-dev-only-do-not-override-i0102m).ant-select-multiple .ant-select-selection-placeholder {\n  color: blue !important;\n}\n\n.searchButton {\n  background-color: var(--primary-blue-600);\n  color: white;\n  font-weight: 500;\n}\n\n.resetButton {\n  color: var(--primary-blue-600);\n  font-weight: 500;\n}\n\n.downloadButton {\n  color: var(--primary-blue-600);\n  font-weight: 500;\n}\n\n.filterContainer {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px;\n}\n\ninput {\n  &::placeholder {\n    color: #3b535c !important;\n    opacity: 0.75;\n  }\n}\n.dynamicFilterElement {\n  &::placeholder {\n    color: #212529 !important;\n    opacity: 0.5 !important;\n  }\n  :global(.ant-select-selection-placeholder) {\n    color: #212529 !important;\n    opacity: 0.5 !important;\n  }\n}\n\n.dynamicFilterInput {\n  &::placeholder {\n    color: #212529 !important;\n    opacity: 0.5 !important;\n  }\n  :global(.ant-select-selection-placeholder) {\n    color: #212529 !important;\n    opacity: 0.5 !important;\n  }\n}\n.dynamicFilterElement {\n  width: 19%;\n}\n\n.ant-table-pagination.ant-pagination {\n  margin: 4px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
